import { createSmartTaxUploadCard } from './createSmartTaxUploadCard';
import {
  SMART_TAX_ORGANIZER_CARD_CONFIG,
  SmartTaxOrganizerTechnicalSpecs,
} from './smartTaxImportCards';

export const SmartTaxOrganizerUploadCard = createSmartTaxUploadCard(
  SMART_TAX_ORGANIZER_CARD_CONFIG,
  SmartTaxOrganizerTechnicalSpecs
);
